import type { MutationCallbacks } from '#shared'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { unref, type MaybeRef } from 'vue'
import { getMessagesQueryKey, type MessagesQueryData } from '#entities/message'
import { deleteReaction } from '../../../widgets/message-list/api/delete-reaction'

type DeleteReactionMutationCallbacks = MutationCallbacks<number, void>

export function useDeleteReactionMutation(
  chatId: MaybeRef<number>,
  messageId: MaybeRef<number>,
  callbacks: DeleteReactionMutationCallbacks = {}
) {
  const queryClient = useQueryClient()

  return useMutation({
    ...callbacks,

    mutationFn: (reactionId: number) => deleteReaction(unref(chatId), unref(messageId), reactionId),

    onSuccess(_response, reactionId) {
      queryClient.setQueryData(getMessagesQueryKey(unref(chatId)), (queryData: MessagesQueryData | undefined) => {
        if (!queryData) return

        const newPages = queryData?.pages.map(page => {
          if (!page.data.some(message => message.id == unref(messageId))) return page

          const newData = page.data.map(message => {
            if (message.id !== unref(messageId)) return message

            return { ...message, reactions: message.reactions.filter(reaction => reaction.id !== reactionId) }
          })

          return {
            ...page,
            data: newData,
          }
        })

        return {
          ...queryData,
          pages: newPages,
        }
      })

      callbacks.onMutate?.(reactionId)
    },
  })
}
